
import React from 'react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { NODE_SHAPES } from "@/utils/shapeUtils";
import { Circle, Cloud, Diamond, Pentagon, Square } from "lucide-react";

interface ShapeSelectorProps {
  selectedShape: string;
  onShapeChange: (shape: string) => void;
}

const ShapeSelector = ({ selectedShape, onShapeChange }: ShapeSelectorProps) => {
  const getShapeIcon = React.useCallback((shape: string) => {
    switch (shape) {
      case "cloud":
        return <Cloud size={18} aria-hidden="true" />;
      case "diamond":
        return <Diamond size={18} aria-hidden="true" />;
      case "circle":
        return <Circle size={18} aria-hidden="true" />;
      case "pentagon":
        return <Pentagon size={18} aria-hidden="true" />;
      case "rectangle":
      default:
        return <Square size={18} aria-hidden="true" />;
    }
  }, []);

  return (
    <div className="flex items-center gap-2" role="group" aria-label="Shape selection">
      <span className="text-sm font-medium mr-2">Shape:</span>
      <RadioGroup
        value={selectedShape}
        onValueChange={onShapeChange}
        className="flex items-center gap-2"
        aria-label="Select node shape"
      >
        {NODE_SHAPES.map((shape) => (
          <div key={shape} className="flex items-center space-x-1">
            <RadioGroupItem 
              value={shape} 
              id={`shape-${shape}`} 
              className="w-4 h-4"
              aria-label={`${shape} shape`}
            />
            <Label htmlFor={`shape-${shape}`} className="flex items-center gap-1 cursor-pointer">
              {getShapeIcon(shape)}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

ShapeSelector.displayName = 'ShapeSelector';

export default ShapeSelector;
